import { getName } from '../../../../utils/treeVisitors/helpers';
import { toUrlFormat } from '../../../../utils/treeVisitors';
import { getMdName } from '../../../../utils/markdownUtils';

export const nodeToMemberFormat = (node) => ({
  type: node.type,
  urlFormat: node.data.urlFormat,
  name: getName(node.data),
  docs: node.data.docs,
});

export const mdGuideToMemberFormat = (md) => {
  const name = getMdName(md);
  return {
    name,
    urlFormat: toUrlFormat(name),
    docs: {
      summary: '',
    },
  };
};

export const isEmpty = (arr) => !(arr && arr.length);

export const hasOneTag = (node) => node?.data?.tags?.length === 1;
